/**
 * The prefix every personal engineer stack's stage name carries, as in
 * `dev_hartman`. Shared stages are `QA`, `QA2`..`QA5` and `Prod`.
 */
export const DEV_ENV_PREFIX = "dev_";

/**
 * Whether this build is pointed at a personal engineer stack.
 *
 * Gates on the deploy stage (`NEXT_PUBLIC_ENV`) rather than `NODE_ENV`, which
 * is `production` for any built app including the one a dev stack serves, and
 * `development` for `next dev` against QA. Only the stage distinguishes "my
 * stack" from "a real environment", which is what an engineer-only affordance
 * has to key off.
 */
export const isDevEnvironment = (
  env: string | undefined = process.env.NEXT_PUBLIC_ENV
): boolean => Boolean(env?.startsWith(DEV_ENV_PREFIX));
